/*
  1-oct-2026 · «Lights out» v2: semáforo de salida de 5 columnas × 2 luces, como en la F1. Las columnas se encienden
  una a una y se apagan tras una espera al azar; se mide el tiempo entre el apagado y el toque (pointerdown, o
  Espacio/Intro con teclado). Por debajo de 0,100 s cuenta como salida nula (se ha adivinado, no reaccionado; es el
  mismo límite que usa el atletismo). El mejor tiempo y los intentos se guardan solo en este navegador
  (localStorage); no se envía nada.

  4-oct-2026 · «Compartir mi tiempo» manda una tarjeta PNG con el tiempo (si el navegador comparte archivos) y un
  enlace con ?variant=<ms>, que snippets/meta-tags.liquid lee para poner el tiempo en la vista previa del enlace. Si no
  se pueden compartir archivos, aparece «Descargar la imagen».

  Lo usan el pop-up del 10 % (sections/rc-newsletter-popup.liquid) y la página del juego (sections/rc-lights-out.liquid),
  con el marcado de snippets/rc-lights-out-game.liquid. Avisa al contenedor con eventos:
    rc-lo:result  → detail { ms, level, best, record, attempts }
    rc-lo:claim   → «Quiero mi 10 %» o «Ir directo a mi 10 %» (solo en el pop-up)
*/
if (!customElements.get('rc-lights-out')) {
  const STRINGS = {
    es: {
      start: 'Ocupa tu posición', hold: 'Mantén tu posición', tap: 'Toca ahora', again: 'Vuelve a la parrilla',
      idleNote: 'Tus reflejos. Tu momento.', armedNote: 'Espera a que se apaguen', goNote: '¡Luces fuera!',
      lateNote: 'Se acabó el tiempo. Prueba otra vez.', pausedNote: 'Salida en pausa. Vuelve a ocupar tu posición.',
      hintIdle: 'Toca cuando se apaguen las luces.', hintTiming: 'Toca el botón o pulsa la barra espaciadora.',
      jump: 'Salida nula', jumpHint: 'Te has adelantado. Un poco de paciencia.',
      levels: ['Nivel piloto', 'Muy rápido', 'Buena salida', 'En la parrilla', 'Sigue practicando'],
      attempt: 'Intento', share: 'Compartir mi tiempo', copied: 'Enlace copiado', copyFailed: 'Copia el enlace de abajo',
      shareTitle: 'Lights out · Race Code',
      shareText: (time, level) => `He hecho ${time} s en Lights out de Race Code (${level}). ¿Me ganas?`,
      tagline: '¿Me ganas?',
      lightsOff: 'Luces de salida apagadas', lightsOn: (n) => `Luces de salida encendidas: ${n} de 5`,
      said: (time, level, record) => `Tu tiempo: ${time} segundos. ${level}.${record ? ' ¡Nuevo récord!' : ''}`,
      zero: '0,000'
    },
    en: {
      start: 'Take your position', hold: 'Hold your position', tap: 'Tap now', again: 'Line up again',
      idleNote: 'Your reaction. Your moment.', armedNote: 'Wait for the lights to go out', goNote: 'Lights out!',
      lateNote: 'Time’s up. Give it another go.', pausedNote: 'Run paused. Take your position again.',
      hintIdle: 'Tap when the lights go out.', hintTiming: 'Tap the button or press Space.',
      jump: 'Jump start', jumpHint: 'Too early. A little patience.',
      levels: ['Pro driver start', 'Very quick', 'Good start', 'On the grid', 'Keep practicing'],
      attempt: 'Attempt', share: 'Share my time', copied: 'Link copied', copyFailed: 'Copy the link below',
      shareTitle: 'Lights out · Race Code',
      shareText: (time, level) => `I clocked ${time} s on Race Code’s Lights out (${level}). Can you beat it?`,
      tagline: 'Can you beat it?',
      lightsOff: 'Starting lights off', lightsOn: (n) => `Starting lights on: ${n} of 5`,
      said: (time, level, record) => `Your time: ${time} seconds. ${level}.${record ? ' New personal best!' : ''}`,
      zero: '0.000'
    }
  };
  const BEST_KEY = 'rc_lo_best';
  const ATTEMPTS_KEY = 'rc_lo_attempts';
  const MIN_REACTION_MS = 100;

  const store = {
    get(key) {
      try { return parseInt(localStorage.getItem(key), 10) || 0; } catch (error) { return 0; }
    },
    set(key, value) {
      try { localStorage.setItem(key, String(value)); } catch (error) {}
    }
  };

  /*
    4-oct-2026 · Tarjeta para compartir el tiempo como imagen (1080 × 1350, PNG), con el estilo del juego: fondo #111,
    semáforo rojo encendido, tiempo grande, nivel en rojo y «¿Me ganas?». Se dibuja al salir el resultado para que
    esté lista al tocar «Compartir mi tiempo» (Safari en iPhone solo deja compartir justo después del toque).
  */
  const CARD = { width: 1080, height: 1350, pad: 88, red: '#e3261c' };
  const CARD_FONTS = ['700 270px', '500 120px', '700 64px', '700 40px', '400 32px', '500 26px'];

  // Espaciado entre letras a mano: ctx.letterSpacing no está en todos los Safari.
  function cardSpaced(ctx, text, x, y, spacing, align) {
    const chars = [...text];
    const widths = chars.map((char) => ctx.measureText(char).width);
    const total = widths.reduce((sum, width) => sum + width, 0) + spacing * (chars.length - 1);
    let left = align === 'right' ? x - total : align === 'center' ? x - total / 2 : x;
    chars.forEach((char, index) => {
      ctx.fillText(char, left, y);
      left += widths[index] + spacing;
    });
  }

  function cardGantry(ctx, centre, top) {
    const colWidth = 150;
    const gap = 22;
    const radius = 50;
    const colHeight = radius * 4 + colWidth * 0.36;
    const left = centre - (5 * colWidth + 4 * gap) / 2;
    for (let col = 0; col < 5; col += 1) {
      const x = left + col * (colWidth + gap);
      ctx.fillStyle = '#1d1d1d';
      ctx.fillRect(x, top, colWidth, colHeight);
      for (let row = 0; row < 2; row += 1) {
        const y = top + colWidth * 0.12 + radius + row * (radius * 2 + colWidth * 0.12);
        ctx.save();
        ctx.shadowColor = 'rgba(227, 38, 28, 0.55)';
        ctx.shadowBlur = radius * 0.9;
        ctx.beginPath();
        ctx.arc(x + colWidth / 2, y, radius, 0, Math.PI * 2);
        ctx.fillStyle = CARD.red;
        ctx.fill();
        ctx.restore();
      }
    }
    return colHeight;
  }

  function drawCard(ctx, { family, logo, time, level, tagline, site }) {
    const { width: W, height: H, pad } = CARD;
    const font = (spec) => `${spec} ${family}`;
    ctx.fillStyle = '#111';
    ctx.fillRect(0, 0, W, H);
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';

    if (logo) {
      const logoHeight = 34;
      ctx.drawImage(logo, pad, pad, (logo.naturalWidth * logoHeight) / logo.naturalHeight, logoHeight);
    } else {
      ctx.fillStyle = '#fff';
      ctx.font = font('700 40px');
      ctx.fillText('RACE CODE', pad, pad + 34);
    }
    ctx.fillStyle = '#8a8a8a';
    ctx.font = font('500 26px');
    cardSpaced(ctx, 'LIGHTS OUT', W - pad, pad + 28, 5, 'right');

    const gantryTop = 230;
    const timeY = gantryTop + cardGantry(ctx, W / 2, gantryTop) + 320;
    ctx.font = font('700 270px');
    const timeWidth = ctx.measureText(time).width;
    ctx.font = font('500 120px');
    const unitWidth = ctx.measureText(' s').width;
    const timeX = (W - timeWidth - unitWidth) / 2;
    ctx.fillStyle = '#fff';
    ctx.font = font('700 270px');
    ctx.fillText(time, timeX, timeY);
    ctx.fillStyle = '#8a8a8a';
    ctx.font = font('500 120px');
    ctx.fillText(' s', timeX + timeWidth, timeY);

    ctx.fillStyle = CARD.red;
    ctx.font = font('700 40px');
    cardSpaced(ctx, level.toLocaleUpperCase(), W / 2, timeY + 92, 6, 'center');

    ctx.fillStyle = '#2b2b2b';
    ctx.fillRect(pad, H - 290, W - pad * 2, 2);
    ctx.fillStyle = '#fff';
    ctx.font = font('700 64px');
    ctx.fillText(tagline, pad, H - 170);
    ctx.fillStyle = '#8a8a8a';
    ctx.font = font('400 32px');
    ctx.fillText(site, pad, H - pad - 4);
  }

  class RCLightsOut extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      // Si el elemento ya estaba definido cuando el navegador lee la etiqueta, aún no tiene hijos: espera al DOM.
      if (!this.querySelector('[data-rc-lo-action]')) {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
        }
        return;
      }
      this.ready = true;
      this.t = STRINGS[this.getAttribute('lang') === 'es' ? 'es' : 'en'];
      this.es = this.getAttribute('lang') === 'es';
      this.phase = 'idle';
      this.timers = [];
      this.frame = 0;
      this.lightsOutAt = 0;
      this.lastResult = null;
      this.record = false;
      this.el = {};
      ['console', 'lamps', 'time', 'note', 'level', 'best', 'best-time', 'record', 'action', 'claim', 'retry',
        'hint', 'share', 'download', 'attempt', 'skip', 'live', 'manual', 'manual-input'].forEach((name) => {
        this.el[name] = this.querySelector(`[data-rc-lo-${name}]`);
      });
      this.cols = [...this.querySelectorAll('.rc-lo2__col')];

      const { action, console: box, retry, claim, skip, share } = this.el;
      const activate = () => {
        if (this.phase === 'armed' || this.phase === 'go') this.react();
        else if (this.phase === 'idle' || this.phase === 'jump') this.begin();
      };
      action.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || event.isPrimary === false) return;
        event.preventDefault();
        activate();
      });
      // Clic sin puntero (lectores de pantalla) y teclado.
      action.addEventListener('click', (event) => { if (event.detail === 0) activate(); });
      action.addEventListener('keydown', (event) => {
        if (event.code !== 'Space' && event.code !== 'Enter') return;
        event.preventDefault();
        if (!event.repeat) activate();
      });
      // Durante la salida también vale tocar el semáforo.
      box.addEventListener('pointerdown', (event) => {
        if (event.isPrimary === false || (this.phase !== 'armed' && this.phase !== 'go')) return;
        event.preventDefault();
        this.react();
      });
      retry?.addEventListener('click', () => this.begin());
      const claimIt = () => this.dispatchEvent(new CustomEvent('rc-lo:claim', { bubbles: true }));
      claim?.addEventListener('click', claimIt);
      skip?.addEventListener('click', claimIt);
      share?.addEventListener('click', () => this.share());
      this.onVisibility = () => {
        if (document.hidden && (this.phase === 'armed' || this.phase === 'go')) this.pause();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.render();
    }

    disconnectedCallback() {
      this.clearTiming();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    get running() {
      return this.phase === 'armed' || this.phase === 'go';
    }

    seconds(ms) {
      const value = (ms / 1000).toFixed(3);
      return this.es ? value.replace('.', ',') : value;
    }

    levelFor(ms) {
      if (ms < 200) return this.t.levels[0];
      if (ms <= 250) return this.t.levels[1];
      if (ms <= 300) return this.t.levels[2];
      if (ms <= 400) return this.t.levels[3];
      return this.t.levels[4];
    }

    clearTiming() {
      this.timers.forEach((id) => window.clearTimeout(id));
      this.timers = [];
      window.cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    lights(n) {
      this.cols.forEach((col, i) => col.classList.toggle('is-lit', i < n));
      this.el.lamps?.setAttribute('aria-label', n ? this.t.lightsOn(n) : this.t.lightsOff);
    }

    say(text) {
      if (this.el.live) this.el.live.textContent = text;
    }

    /* Vuelve al principio (al abrir o cerrar el pop-up). */
    reset() {
      if (!this.ready) return;
      this.clearTiming();
      this.phase = 'idle';
      this.record = false;
      this.lights(0);
      this.render();
    }

    /* Corta una salida a medias (pestaña oculta, cambio de paso del pop-up). */
    pause() {
      if (!this.ready || !this.running) return;
      this.reset();
      this.el.note.textContent = this.t.pausedNote;
      this.say(this.t.pausedNote);
    }

    begin() {
      if (!this.isConnected || this.offsetParent === null) return;
      this.clearTiming();
      this.phase = 'armed';
      this.record = false;
      this.lights(0);
      this.render();
      this.say(this.t.armedNote);
      for (let n = 1; n <= 5; n += 1) {
        this.timers.push(window.setTimeout(() => { if (this.phase === 'armed') this.lights(n); }, (n - 1) * 550 + 100));
      }
      const hold = 950 + Math.random() * 1750;
      this.timers.push(window.setTimeout(() => {
        if (this.phase !== 'armed') return;
        this.frame = window.requestAnimationFrame(() => {
          if (this.phase !== 'armed') return;
          this.lights(0);
          this.phase = 'go';
          this.lightsOutAt = performance.now();
          this.render();
          this.say(this.t.goNote);
          this.timers.push(window.setTimeout(() => {
            if (this.phase !== 'go') return;
            this.reset();
            this.el.note.textContent = this.t.lateNote;
            this.say(this.t.lateNote);
          }, 15000));
        });
      }, 2300 + hold));
    }

    react() {
      const now = performance.now();
      const wasGo = this.phase === 'go';
      const ms = Math.round(now - this.lightsOutAt);
      this.clearTiming();
      this.lights(0);
      const attempts = store.get(ATTEMPTS_KEY) + 1;
      store.set(ATTEMPTS_KEY, attempts);
      if (!wasGo || ms < MIN_REACTION_MS) {
        this.phase = 'jump';
        this.render();
        this.say(`${this.t.jump}. ${this.t.jumpHint}`);
        return;
      }
      const best = store.get(BEST_KEY);
      this.record = !best || ms < best;
      if (this.record) store.set(BEST_KEY, ms);
      const level = this.levelFor(ms);
      this.lastResult = { ms, level, time: this.seconds(ms) };
      this.offerDownload = false;
      this.manualLink = '';
      this.prepareCard(this.lastResult);
      this.phase = 'result';
      this.render();
      this.say(this.t.said(this.seconds(ms), level, this.record));
      (this.el.claim || this.el.retry)?.focus({ preventScroll: true });
      this.dispatchEvent(new CustomEvent('rc-lo:result', {
        bubbles: true,
        detail: { ms, level, best: Math.min(ms, best || ms), record: this.record, attempts }
      }));
    }

    // 4-oct-2026 · El enlace lleva el tiempo (?variant=222): la vista previa del enlace lo muestra aunque la app descarte el
    // texto. Va en «variant» porque la caché de páginas de Shopify ignora parámetros propios como «t» y servía a todos el
    // tiempo del primero; «variant» sí cuenta para la caché, no cambia la canónica y en una página no hace nada más.
    shareLink(ms) {
      try {
        const link = new URL(this.dataset.shareUrl || '/pages/lights-out', window.location.origin);
        link.searchParams.set('variant', String(ms));
        // 11-oct-2026 · Etiquetas UTM para medir en el panel cuántas visitas y ventas traen los tiempos compartidos.
        link.searchParams.set('utm_source', 'lightsout');
        link.searchParams.set('utm_medium', 'share');
        link.searchParams.set('utm_campaign', this.dataset.season || 'lights-out');
        return link.toString();
      } catch (error) {
        return this.dataset.shareUrl || window.location.origin;
      }
    }

    cardLogo() {
      if (!this.logoPromise) {
        this.logoPromise = new Promise((resolve) => {
          const src = this.dataset.shareLogo;
          if (!src) { resolve(null); return; }
          const logo = new Image();
          logo.crossOrigin = 'anonymous';
          logo.onload = () => resolve(logo);
          logo.onerror = () => resolve(null);
          logo.src = src;
        });
      }
      return this.logoPromise;
    }

    async prepareCard(result) {
      const token = (this.cardToken || 0) + 1;
      this.cardToken = token;
      this.cardFile = null;
      try {
        const family = getComputedStyle(this.el.time).fontFamily || 'sans-serif';
        await Promise.all(CARD_FONTS.map((spec) => document.fonts.load(`${spec} ${family}`).catch(() => null)));
        const logo = await this.cardLogo();
        const canvas = document.createElement('canvas');
        canvas.width = CARD.width;
        canvas.height = CARD.height;
        drawCard(canvas.getContext('2d'), { family, logo, time: result.time, level: result.level, tagline: this.t.tagline, site: 'race-code.com' });
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
        if (!blob || token !== this.cardToken) return;
        const name = `race-code-lights-out-${result.time.replace(/[.,]/, '-')}.png`;
        this.cardFile = new File([blob], name, { type: 'image/png' });
        if (this.cardUrl) URL.revokeObjectURL(this.cardUrl);
        this.cardUrl = URL.createObjectURL(blob);
        if (this.el.download) {
          this.el.download.href = this.cardUrl;
          this.el.download.download = name;
        }
      } catch (error) {
        this.cardFile = null;
      }
    }

    async share() {
      if (!this.lastResult) return;
      const url = this.shareLink(this.lastResult.ms);
      const text = this.t.shareText(this.lastResult.time, this.lastResult.level);
      const file = this.cardFile;
      // Primero, la tarjeta como foto (iPhone, Android, Safari en Mac), con el texto y el enlace.
      if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({ files: [file], text: `${text} ${url}` });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }
      // Sin fotos: se ofrece descargar la tarjeta junto al enlace.
      this.offerDownload = Boolean(this.cardUrl);
      this.render();
      if (navigator.share) {
        try {
          await navigator.share({ title: this.t.shareTitle, text, url });
          return;
        } catch (error) {
          if (error && error.name === 'AbortError') return;
        }
      }
      let message = this.t.copied;
      try {
        await navigator.clipboard.writeText(`${text} ${url}`);
      } catch (error) {
        message = this.t.copyFailed;
        // 7-oct-2026 · Si el navegador no deja copiar, el enlace sale en un campo ya seleccionado para copiarlo a mano.
        this.manualLink = url;
        this.render();
        const input = this.el['manual-input'];
        if (input) {
          input.focus({ preventScroll: true });
          input.setSelectionRange(0, input.value.length);
        }
      }
      const label = this.el.share.querySelector('span') || this.el.share;
      label.textContent = message;
      this.say(message);
      window.clearTimeout(this.shareTimer);
      this.shareTimer = window.setTimeout(() => { label.textContent = this.t.share; }, 2400);
    }

    render() {
      const p = this.phase;
      const { t, el } = this;
      const best = store.get(BEST_KEY);
      el.console.dataset.phase = p;
      this.dataset.phase = p;
      el.time.textContent = p === 'result' ? this.lastResult.time : t.zero;
      el.note.hidden = p === 'result' || p === 'jump';
      el.note.textContent = { armed: t.armedNote, go: t.goNote }[p] || t.idleNote;
      el.level.hidden = !(p === 'result' || p === 'jump');
      el.level.textContent = p === 'jump' ? t.jump : (this.lastResult?.level || '');
      el.action.hidden = p === 'result';
      el.action.textContent = { armed: t.hold, go: t.tap, jump: t.again }[p] || t.start;
      el.action.classList.toggle('rc-lo2__button--ghost', p === 'armed');
      if (el.claim) el.claim.hidden = p !== 'result';
      el.retry.hidden = p !== 'result';
      el.retry.classList.toggle('rc-lo2__button--ghost', Boolean(el.claim));
      el.retry.closest('.rc-lo2__actions')?.classList.toggle('rc-lo2__actions--two', p === 'result' && Boolean(el.claim));
      el.best.hidden = !best;
      if (best) el['best-time'].textContent = `${this.seconds(best)} s`;
      el.record.hidden = !(p === 'result' && this.record);
      el.hint.hidden = p === 'result';
      el.hint.textContent = p === 'jump' ? t.jumpHint : (this.running ? t.hintTiming : t.hintIdle);
      if (el.skip) el.skip.hidden = !(p === 'idle' || p === 'jump');
      el.share.hidden = p !== 'result' || !(navigator.share || navigator.clipboard);
      if (el.download) el.download.hidden = !(p === 'result' && this.offerDownload && this.cardUrl);
      if (el.manual) {
        el.manual.hidden = !(p === 'result' && this.manualLink);
        if (el['manual-input'] && el['manual-input'].value !== (this.manualLink || '')) el['manual-input'].value = this.manualLink || '';
      }
      el.attempt.hidden = p !== 'result';
      el.attempt.textContent = `${t.attempt} ${store.get(ATTEMPTS_KEY)}`;
    }
  }

  customElements.define('rc-lights-out', RCLightsOut);
}
